/** 数据修正 */
export default {
    openId: "开放id", // 开放id
    openIdPlaceholder: "请输入开放id", // 请输入开放id
    organisation: "组织架构", // 组织架构
    organisationName: "组织名称", // 组织名称 organisation name
    organisationNamePlaceholder: "请输入组织名称 ", // 请输入组织名称
    affiliatedOrganisation: "所属组织", // 所属组织
    entity: "实体", // 实体
    entityId: "实体id", // 实体id
    entityName: "实体名称", // 实体名称 entity name
    entityNamePlaceholder: "请输入实体名称", // 请输入实体名称
    sortNumber: "排序序号", // 实体排序
    entityType: "实体类型", // 实体类型
    businessHours: "营业时间", // 营业时间
    businessStartTime: "营业开始时间", // 营业开始时间
    closingTime: "营业结束时间", // 营业结束时间
    passagewayName: "出入口名称", // 出入口名称 Entry and exit management
    passagewayNamePlaceholder: "请输入出入口名称", // 请输入出入口名称
    maximumCapacity: "最大容纳人数", // 最大容纳人数
    maxInstant: "最大瞬时人数", // 最大瞬时人数
    inWarningNum: "预警进人数", // 预警进人数
    passengerBasic: "客流基数", // 客流基数
    totalPassenger: "总客流人数", // 总客流人数
    today: "今日日期", // 今日日期
    storePhone: "门店电话", // 门店电话
    linker: "联系人姓名", // 联系人姓名
    linkerPlaceholder: "请输入联系人姓名", // 请输入联系人姓名
    address: "详细地址", // 详细地址
    linkerPhone: "联系人手机", // 联系人手机
    entryNumber: "进人数", // 进人数 walk into
    exitNumber: "出人数", // 出人数 walk pass
    passingsNumber: "经过人数", // 经过人数 walk pass
    manNumber: "男客流量", // 男客流量
    girlNumber: "女客流量", // 女客流量
    strandNumber: "滞留人数", // 滞留人数 people staying
    whetherToCalculate: "是否需要计算", // 是否需要计算 Whether to calculate
    needToCalculate: "需要计算", // 需要计算
    noNeedToCalculate: "不需要计算", // 不需要计算
    currentOneMinute: "一分钟时间", // 一分钟时间
    currentFiveMinute: "所在五分钟", // 所在五分钟
    currentHour: "所在小时", // 所在小时
    currentDate: "所在天", // 所在天
    currentMonth: "所在月", // 所在月
    searchTime: "搜索时间", // 搜索时间
    startTime: "开始时间", // 开始时间
    endTime: "结束时间", // 结束时间
    serialNumber: "序列号", // 序列号
    serialNumberPlaceholder: "请输入序列号", // 请输入序列号
    equipmentAlias: "设备别名", // 设备别名
    warrantyExpirationDate: "质保到期", // 质保到期
    serviceExpirationDate: "服务到期", // 服务到期
    model: "型号", // 型号
    versionNumber: "版本号", // 版本号
    iccid: "SIM 卡号", // SIM 卡号
    onlineState: "在线状态", // 在线状态
    isBind: "查询未绑定设备", // 是否绑定出入口
    bindPassageway: "绑定出入口", // 绑定出入口
    transmitterPower: "发射端电量", // 发射端电量
    receiverPower: "接收端电量", // 接收端电量
    heartbeatTime: "心跳时间", // 心跳时间
    reportedTime: "最后上报时间", // 最后上报时间
    learningStatus: "学习状态", // 学习状态
}